import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import App from './App';
import './styles.css';
import './styles/pages.css';
import './styles/auth.css';
import './components/Header.css';
import './components/Footer.css';
import './components/LoginModal.css';
import './components/UserMenu.css';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
      <App />
        </AuthProvider>
      </QueryClientProvider>
    </StrictMode>
  );
} else {
  console.error('Root element not found');
}
